const onDotClick = (e) => {
    const dot = e.target;
    const hiddenText = dot.parentNode.querySelector(".small-hide");

    if(!hiddenText) {
        const textToHide = dot.parentNode.querySelector("span");
        textToHide.classList.add("small-hide");

        dot.parentNode.insertBefore(textToHide, dot);
        return;
    }
    
    hiddenText.classList.remove("small-hide");
    dot.parentNode.appendChild(dot);
    
};

document.addEventListener("DOMContentLoaded", function() {
    const dots = Array.from(document.querySelectorAll(".image-with-text__text .dots"));

    if (dots.length) {
        dots.forEach(dot => {
            dot.addEventListener("click", onDotClick);
        });
    }
});